export default __webpack_public_path__ + "static/media/raw-about.42f5a51e.jpg";